import { tabungan } from '../action-types';

const initialState = {
  data: null,
  dataByNis: null,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case tabungan.FETCH_TABUNGAN:
      return {
        ...state,
        isFetching: true,
      };
    case tabungan.GET_TABUNGAN:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case tabungan.GET_TABUNGAN_BY_NIS:
      return {
        ...state,
        isFetching: false,
        dataByNis: action.payload,
      };
    case tabungan.GET_TABUNGAN_BY_NIS_FAIL:
      return {
        ...state,
        isFetching: false,
        dataByNis: action.payload,
      };
    default:
      return state;
  }
};
